import React from "react";
import { BsFacebook, BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900">
      <div className="w-full max-w-screen-xl mx-auto p-4 md:py-6">
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            Chabbikar
          </span>
          <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
            <li>
              <a href="/" className="mr-4 hover:underline md:mr-6 ">
                About
              </a>
            </li>
            <li>
              <a href="/" className="mr-4 hover:underline md:mr-6">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/" className="mr-4 hover:underline md:mr-6 ">
                Licensing
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Contact
              </a>
            </li>
          </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-6" />
        <div className="flex items-center justify-center mt-10 mb-10 gap-8">
          <Link to="https://www.facebook.com/profile.php?id=100091940354602">
            <BsFacebook
              className="text-blue-800 dark:text-white cursor-pointer"
              size={25}
            />
          </Link>
          <Link to="https://twitter.com/chabbhikar">
            <BsTwitter
              className="text-blue-500 dark:text-white cursor-pointer"
              size={25}
            />
          </Link>
          <Link to="https://www.instagram.com/chabbhikar/?hl=en">
            <BsInstagram
              className="text-pink-800 dark:text-white cursor-pointer"
              size={25}
            />
          </Link>
          <Link to="https://www.linkedin.com/in/chabbhikar-the-artist-79642226b">
            <BsLinkedin
              className="text-blue-800 dark:text-white cursor-pointer"
              size={25}
            />
          </Link>
        </div>
        <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">
          © 2023 Chabbikar™ . All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
